import { GetAllQueryParams, Supplier, SupplierGet, SupplierSearch } from "../interfaces/supplier";

import axiosInstance from "./axios-instance";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const getAll = async (queryParams?: GetAllQueryParams) => {
    try {
        const scopedAccountId = getScopedAccountId(queryParams?.accountId);
        const response = await axiosInstance.get<Supplier[]>("/supplier", {
            params: {
                ...queryParams,
                accountId: scopedAccountId,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching suppliers:", error);
        throw error;
    }
};

const getSuppliers = async (queryParams?: GetAllQueryParams) => {
    try {
        const scopedAccountId = getScopedAccountId(queryParams?.accountId);
        const response = await axiosInstance.get<Supplier[]>("/supplier/get-all", {
            params: {
                ...queryParams,
                accountId: scopedAccountId,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching suppliers:", error);
        throw error;
    }
};

const getSupplier = async (queryParams: SupplierGet) => {
    try {
        const scopedAccountId = getScopedAccountId(queryParams.accountId);
        const response: any = await axiosInstance.get<SupplierGet>(
            `/supplier/get?id=${queryParams.supplierId}&accountId=${scopedAccountId}`
        );

        return response.data;
    } catch (error) {
        console.error("Error with get supplier:", error);
        throw error;
    }
};

const addSupplier = async (queryParams?: any) => {
    try {
        const scopedAccountId = getScopedAccountId(queryParams?.accountId);
        const response = await axiosInstance.post(`/supplier/add`, {
            ...queryParams,
            accountId: scopedAccountId,
        });

        return response.data;
    } catch (error) {
        console.error("Error adding supplier:", error);
        throw error;
    }
};

const editSupplier = async (queryParams: any) => {
    try {
        const scopedAccountId = getScopedAccountId(queryParams?.accountId);
        const response = await axiosInstance.post('/supplier/edit', {
            ...queryParams,
            accountId: scopedAccountId,
        });

        return response.data;
    } catch (error) {
        console.error("Error editing supplier:", error);
        throw error;
    }
};

const searchSuppliers = async (queryParams: SupplierSearch) => {
    try {
        const scopedAccountId = getScopedAccountId(queryParams.accountId);
        const response: any = await axiosInstance.get<SupplierSearch>(
            `/supplier/search_suppliers?text=${queryParams.text}&accountId=${scopedAccountId}&excludeId=${queryParams.excludeId}&includeInactive=${queryParams.includeInactive}&nameSort=${queryParams.nameSort}&typeSort=${queryParams.typeSort}`
        );

        return response.data;
    } catch (error) {
        console.error("Error with search suppliers:", error);
        throw error;
    }
};

export { getAll, getSuppliers, getSupplier, addSupplier, editSupplier, searchSuppliers };
